export default __webpack_public_path__ + "static/media/formulaAccepted.9667eae4.svg";